import comp from "./AddClassModal";
export default comp;
